import Step from "@fae/source/models/Step.js"

function toPathKey(a, b) {
    return a.x + "x" + a.y + "to" + b.x + "x" + b.y
}

// {width = 13, height = 7}
export default function GenerateOverworldMap({width = 10, height = 5} = {}) {
    return function(stage) {
        const overworld = {
            "images": [
                {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-3-base.lowres.png")},
                {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-2-beacon-DIM.png")},
                // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-2-beacon-LIT.png")},
                // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier3.png")},
                // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier2.png")},
                // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier1.png")},
                // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-0-eyes.png")},
                // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-examplepath.png")},
                {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.lowres.png"), "blendmode": "overlay", "opacity": 0.2},
                {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.lowres.png"), "size": "contain"},
            ],
            "encounters": [
                // {"position": {"x": 0, "y": 2}, "wasSelected": true},
                //
                // {"position": {"x": 1, "y": 0}},
                // {"position": {"x": 1, "y": 1}},
                // {"position": {"x": 1, "y": 2}},
                // {"position": {"x": 1, "y": 3}},
                // {"position": {"x": 1, "y": 4}},
                //
                // {"position": {"x": 2, "y": 0}},
                // {"position": {"x": 2, "y": 1}},
                // {"position": {"x": 2, "y": 2}},
                // {"position": {"x": 2, "y": 3}},
                // {"position": {"x": 2, "y": 4}},
                //
                // {"position": {"x": 3, "y": 0}},
                // {"position": {"x": 3, "y": 1}},
                // {"position": {"x": 3, "y": 2}},
                // {"position": {"x": 3, "y": 3}},
                // {"position": {"x": 3, "y": 4}},
                //
                // {"position": {"x": 4, "y": 0}},
                // {"position": {"x": 4, "y": 1}},
                // {"position": {"x": 4, "y": 2}, "type": "elite"},
                // {"position": {"x": 4, "y": 3}},
                // {"position": {"x": 4, "y": 4}},
                //
                // {"position": {"x": 5, "y": 0}},
                // {"position": {"x": 5, "y": 1}},
                // {"position": {"x": 5, "y": 2}, "type": "elite"},
                // {"position": {"x": 5, "y": 3}},
                // {"position": {"x": 5, "y": 4}},
                //
                // {"position": {"x": 6, "y": 0}},
                // {"position": {"x": 6, "y": 1}},
                // {"position": {"x": 6, "y": 2}, "type": "elite"},
                // {"position": {"x": 6, "y": 3}},
                // {"position": {"x": 6, "y": 4}},
                //
                // {"position": {"x": 7, "y": 0}},
                // {"position": {"x": 7, "y": 1}},
                // {"position": {"x": 7, "y": 2}, "type": "elite"},
                // {"position": {"x": 7, "y": 3}},
                // {"position": {"x": 7, "y": 4}},
                //
                // {"position": {"x": 8, "y": 0}},
                // {"position": {"x": 8, "y": 1}},
                // {"position": {"x": 8, "y": 2}, "type": "elite"},
                // {"position": {"x": 8, "y": 3}},
                // {"position": {"x": 8, "y": 4}},
                //
                // {"position": {"x": 9, "y": 2}},
                // {"position": {"x": 10, "y": 2}},
            ],
            "paths": {
                "0x2to1x1": true,
                "0x2to1x2": true,
                "0x2to1x3": true,

                "1x3to2x3": true,
                "1x3to2x4": true,
            },
            "player": {
                "position": {"x": 0, "y": 4}
            },
            "width": undefined,
            "height": undefined,
        }

        overworld.width = width
        overworld.height = height

        // Step 1: List every possible encounter at every possible position.
        overworld.encounters = []
        for(let y = 0; y < height; y += 1) {
            for(let x = 0; x < width; x += 1) {
                overworld.encounters.push({
                    "position": {x, y}
                })
            }
        }

        // Step 2: Do a drunk walk, following a few key rules:
        // - jump from left to right
        // - jumps up or down or straight ahead
        // - do not leave bounds of the map
        // - do not cross an adjacent path, making an x with the paths.
        overworld.paths = {}
        const PATH_COUNT = 3
        for(let i = 0; i < PATH_COUNT; i += 1) {
            // let previousPosition = {"x": -1, "y": Math.floor(Math.random() * overworld.height)}
            // let previousPosition = {"x": -1, "y": Math.floor(overworld.height / 2)}
            let previousPosition = {"x": -1, "y": overworld.height - 1}
            while(previousPosition.x < overworld.width) {
                const nextPositions = [{"x": previousPosition.x + 1, "y": previousPosition.y}]
                if(previousPosition.x != -1
                && previousPosition.x != overworld.width - 1) {
                    if(previousPosition.y != 0) {
                        const forbiddenPath = overworld.paths[toPathKey(
                            {"x": previousPosition.x, "y": previousPosition.y - 1},
                            {"x": previousPosition.x + 1, "y": previousPosition.y}
                        )]
                        if(forbiddenPath == undefined) {
                            nextPositions.push({"x": previousPosition.x + 1, "y": previousPosition.y - 1})
                        }
                    }
                    if(previousPosition.y != overworld.height - 1) {
                        const forbiddenPath = overworld.paths[toPathKey(
                            {"x": previousPosition.x, "y": previousPosition.y + 1},
                            {"x": previousPosition.x + 1, "y": previousPosition.y}
                        )]
                        if(forbiddenPath == undefined) {
                            nextPositions.push({"x": previousPosition.x + 1, "y": previousPosition.y + 1})
                        }
                    }
                }
                const nextPosition = stage.random.element(nextPositions)
                overworld.paths[toPathKey(previousPosition, nextPosition)] = {
                    "previousPosition": previousPosition,
                    "nextPosition": nextPosition
                }
                previousPosition = nextPosition
            }
        }

        // Step 3. Remove any unused unreachable encounters.
        overworld.encounters = overworld.encounters.filter((encounter) => {
            encounter.outgoingPaths = Object.values(overworld.paths).filter((path) => {
                return encounter.position.x == path.previousPosition.x
                    && encounter.position.y == path.previousPosition.y
            })
            encounter.incomingPaths = Object.values(overworld.paths).filter((path) => {
                return encounter.position.x == path.nextPosition.x
                    && encounter.position.y == path.nextPosition.y
            })
            return encounter.incomingPaths.length > 0
        })
        // Step 4. Set type, based on floor number and proceeding spot
    	// - Have an odds table for the different event types, as seen here: https://steamcommunity.com/sharedfiles/filedetails/?id=2830078257
    	// - no elite or campfire too early, before the 1/3 mark.
    	// - elite, merchant and campfire can't have the same type as the preceeding spot ALSO check if you're just under the treasure room column, so you don't put treasure here.
    	// - can't have the same type as it's siblings if they share a parent. each branch must only have unique options, no dupes.
    	// - Some columns just automatically get a certain type. boss column, with campfire column just before it. basic monsters only in the first column. and treasure at a set encounter!!!
        overworld.encounters.forEach((encounter) => {
            if(encounter.position.x == 0) {
                encounter.type = "first-combat"
                return
            }
            if(encounter.position.x == overworld.width - 2) {
                encounter.type = "final-combat"
                return
            }
            if(encounter.position.x == overworld.width - 1) {
                encounter.type = "exit"
                return
            }
            if(encounter.position.x == Math.ceil(overworld.width / 2)) {
                encounter.type = "treasure"
                return
            }

            // TODO: use the preceeding encounter's following encounters to determine adjacent encounters? and not just geospatially adjacent?
            encounter.preceedingEncounters = encounter.incomingPaths.map((path) => overworld.encounters.find((previousEncounter) => previousEncounter.position.x == path.previousPosition.x && previousEncounter.position.y == path.previousPosition.y))
            encounter.followingEncounters = encounter.outgoingPaths.map((path) => overworld.encounters.find((nextEncounter) => nextEncounter.position.x == path.nextPosition.x && nextEncounter.position.y == path.nextPosition.y))
            encounter.adjacentEncounters = [
                overworld.encounters.find((adjacentEncounter) => adjacentEncounter.position.x == encounter.position.x && adjacentEncounter.position.y == encounter.position.y - 1),
                overworld.encounters.find((adjacentEncounter) => adjacentEncounter.position.x == encounter.position.x && adjacentEncounter.position.y == encounter.position.y + 1),
            ]

            const encounterTypes = ["standard-combat"]
            const adjacentEncounterTypes = encounter.adjacentEncounters.map((encounter) => encounter?.type)
            const preceedingEncounterTypes = encounter.preceedingEncounters.map((encounter) => encounter?.type)
            const followingEncounterTypes = encounter.followingEncounters.map((encounter) => encounter?.type)

            // - no elite or campfire too early, before the 1/3 mark.
            // - elite, merchant and campfire can't have the same type as the preceeding spot
            // - can't have the same type as it's siblings if they share a parent. each branch must only have unique options, no dupes.
            if(encounter.position.x >= 2
            && preceedingEncounterTypes.includes("elite-combat") == false
            && adjacentEncounterTypes.includes("elite-combat") == false
            && followingEncounterTypes.includes("elite-combat") == false) {
                encounterTypes.push("elite-combat")
            }

            // - no elite or campfire too early, before the 1/3 mark.
            // - elite, merchant and campfire can't have the same type as the preceeding spot
            // - can't have the same type as it's siblings if they share a parent. each branch must only have unique options, no dupes.
            if(encounter.position.x >= 2
            && preceedingEncounterTypes.includes("campfire") == false
            && adjacentEncounterTypes.includes("campfire") == false
            && followingEncounterTypes.includes("campfire") == false) {
                encounterTypes.push("campfire")
            }

            // // - elite, merchant and campfire can't have the same type as the preceeding spot
        	// // - can't have the same type as it's siblings if they share a parent. each branch must only have unique options, no dupes.
            // if(preceedingEncounterTypes.includes("merchant") == false
            // && adjacentEncounterTypes.includes("merchant") == false
            // && followingEncounterTypes.includes("merchnat") == false) {
            //     encounterTypes.push("merchant")
            // }

            // - elite, merchant and campfire can't have the same type as the preceeding spot
        	// - can't have the same type as it's siblings if they share a parent. each branch must only have unique options, no dupes.
            if(encounter.position.x > 2
            && adjacentEncounterTypes.includes("random") == false) {
                encounterTypes.push("random")
            }

            while(encounterTypes.includes(encounter.type) == false) {
                encounter.type = stage.random.elementweighted([
                    {"value": "standard-combat", "weight": 0.30},
                    {"value": "elite-combat", "weight": 0.25},
                    {"value": "campfire", "weight": 0.40},
                    {"value": "random", "weight": 0.05},

                    // {"value": "standard-combat", "weight": 0.16},
                    // {"value": "random", "weight": 0.22},
                    // {"value": "elite-combat", "weight": 0.45},
                    // {"value": "campfire", "weight": 0.12},
                    // {"value": "merchant", "weight": 0.05},
                    // {"value": "treasure", "weight": 0}
                    // {"value": "final-combat", "weight": 0}
                ])
            }
        })

        // Step 5. Set the player's starting position!!
        overworld.player = {"position": {"x": -1, "y": overworld.height / 2}}

        window.overworld = overworld
        return Step.deltastage({
            "overworld": overworld
        })
    }
}
